import { render, staticRenderFns } from "./DashboardImage.vue?vue&type=template&id=fa936900&scoped=true&"
import script from "./DashboardImage.vue?vue&type=script&lang=js&"
export * from "./DashboardImage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardImage.vue?vue&type=style&index=0&id=fa936900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_@babel+core@7.19.3__cache-loader@4.1.0_web_c7e2a9737e7b7d65140c95ac56c8a121/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa936900",
  null
  
)

export default component.exports